export enum AccountabilityReceiptStatusEnum {
  PENDING,
  ACCEPTED,
  REJECTED,
  CORRECTION
}
